import { render, staticRenderFns } from "./NewOpportunities.vue?vue&type=template&id=b7ea522a&scoped=true"
import script from "./NewOpportunities.vue?vue&type=script&lang=js"
export * from "./NewOpportunities.vue?vue&type=script&lang=js"
import style0 from "./NewOpportunities.vue?vue&type=style&index=0&id=b7ea522a&prod&lang=scss&scoped=true"
import style1 from "./NewOpportunities.vue?vue&type=style&index=1&id=b7ea522a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ea522a",
  null
  
)

export default component.exports